// extracted by mini-css-extract-plugin
export default {"container":"start_container__kcbWH","button":"start_button__lIEY+","actionWrapper":"start_actionWrapper__47K7f","resultText":"start_resultText__LJO6i"};